import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { skipWhile, switchMap, take } from 'rxjs';

import { AuthService } from 'src/app/modules/core/services/auth.service';

import { RootFacade } from 'src/app/modules/ngrx-store/facade';

export function hasConstructionUpdatesPostCloseGuard(): CanMatchFn {
	return () => {
		const rootFacade = inject(RootFacade);
		const authService = inject(AuthService);

		return authService.canActivate().pipe(
			skipWhile(canActivate => !canActivate),
			take(1),
			switchMap(() => rootFacade.yourHomeFacade.homeDetailsPending$),
			skipWhile(pending => !!pending), // Make sure home details have loaded
			switchMap(() => rootFacade.constructionProgressFacade.constructionUpdatesPending$),
			skipWhile(pending => !!pending), // Make sure construction updates have loaded
			switchMap(() => rootFacade.postCloseWithUpdates$)
		);
	}
}